export default [
  {
    header: 'breadcrumb.conversation',
    resource: 'dashboard',
  },
  {
    title: 'breadcrumb.dashboard',
    route: 'dashboard',
    icon: 'PieChartIcon',
    resource: 'dashboard',
    action: 'read',
  },
];